import { fetchGet, fetchPost } from '../../providers/Fetch';

import {
  LOGIN_AUTH_ERROR, LOGIN_ERROR, LOGIN_REQUEST, LOGIN_SUCCESS, LOGOUT,
} from './types';

export const loginAuthError = error => ({
  type: LOGIN_AUTH_ERROR,
  error,
});

export const loginError = error => ({
  type: LOGIN_ERROR,
  error,
});

export const loginRequest = {
  type: LOGIN_REQUEST,
};

export const loginSuccess = data => ({
  type: LOGIN_SUCCESS,
  data,
});

export const logoutAction = {
  type: LOGOUT,
};

export const checkUser = () => async (dispatch) => {
  dispatch(loginRequest);
  try {
    const result = await fetchGet('/user/testAuth');
    dispatch(loginSuccess(result));
  } catch (e) {
    dispatch(loginAuthError(e.message));
  }
};

export const login = data => async (dispatch) => {
  dispatch(loginRequest);
  try {
    const result = await fetchPost('/user/login', data);
    if (!result) {
      dispatch(loginError('No results found'));
    } else {
      dispatch(loginSuccess(result));
    }
  } catch (e) {
    dispatch(loginError(e.message));
  }
};

export const logout = () => async (dispatch) => {
  try {
    await fetchGet('/user/logout');
    dispatch(logoutAction);
  } catch (e) {
    dispatch(loginError(e.message));
  }
};
